import { withAuth } from '@/utilities/queries';
import {
  updateCoupon as updateCouponService,
  getCoupon as getCouponService,
  deleteCoupon as deleteCouponService,
} from '@simplywallst/services';
import type { PlanType } from '@simplywallst/services';
import type { Plans } from './interface';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { CouponState } from '@/hooks/useUser';
export interface BillingUser {
  userPlanId: string;
  isUserGuest: boolean;
  isUserTrialing: boolean;
  daysUntilTrialEnds: string;
  hasPaymentDetails: boolean;
  userEmail: string;
  userCountryIso: string;
  hasTrialExpired: boolean;
  hasCanceled: boolean;
  daysUntilCancel: string;
}
export interface PageData {
  plansData: Plans[];
  userPlanName: string;
  userPlanType: PlanType;
}

export const defaultCoupon = {
  id: '',
  name: '',
  percentOff: 0,
  amountOff: 0,
  duration: '',
  durationMonths: 0,
  maxRedemptions: 0,
  redeemBy: 0,
  timesRedeemed: 0,
  deleted: false,
};

export const getCoupon = async ({
  queryKey: [_key, urlCoupon],
}: QueryFunctionContext<[string, string | null]>): Promise<
  CouponState | undefined
> => {
  try {
    if (!urlCoupon) return defaultCoupon;
    const response = await getCouponService(urlCoupon);
    const coupon = response.data.data;
    return {
      ...coupon,
      percentOff: coupon.percent_off || 0,
      amountOff: coupon.amount_off || 0,
      duration: coupon.duration || '',
      durationMonths: coupon.duration_months || 0,
      maxRedemptions: coupon.max_redemptions || 0,
      redeemBy: coupon.redeem_by || 0,
      timesRedeemed: coupon.times_redeemed || 0,
    };
  } catch {
    console.error('Get Coupon error');
    return undefined;
  }
};

export const mutateUserCoupon = async (coupon: string) => {
  const response = await withAuth(updateCouponService, coupon);
  return response.data;
};

export const deleteCoupon = async () => {
  await withAuth(deleteCouponService);
};
